import moment from 'moment-timezone';

import { RecordSearchDateRangeValue } from './types';

export const dateRangesAreEqual = (
  a: RecordSearchDateRangeValue,
  b: RecordSearchDateRangeValue
): boolean => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return (
      a[0].toISOString() === b[0].toISOString() &&
      a[1].toISOString() === b[1].toISOString()
    );
  } else {
    return a === b;
  }
};

// complexity 19
// eslint-disable-next-line complexity
export const dateRangeFromValue = (
  value: RecordSearchDateRangeValue
): [Date, Date] => {
  if (Array.isArray(value)) {
    return value;
  } else if (value === '15m') {
    return [moment().subtract(15, 'minutes').toDate(), new Date()];
  } else if (value === '60m') {
    return [moment().subtract(60, 'minutes').toDate(), new Date()];
  } else if (value === '3h') {
    return [moment().subtract(3, 'hours').toDate(), new Date()];
  } else if (value === '12h') {
    return [moment().subtract(12, 'hours').toDate(), new Date()];
  } else if (value === '24h') {
    return [moment().subtract(24, 'hours').toDate(), new Date()];
  } else if (value === 'today') {
    return [moment().startOf('day').toDate(), new Date()];
  } else if (value === 'yesterday') {
    return [
      moment().startOf('day').subtract(1, 'day').toDate(),
      moment().startOf('day').toDate(),
    ];
  } else if (value === '3d') {
    return [moment().subtract(3, 'days').toDate(), new Date()];
  } else if (value === '7d') {
    return [moment().subtract(7, 'days').toDate(), new Date()];
  } else if (value === 'thisweek') {
    return [moment().startOf('week').toDate(), new Date()];
  } else if (value === 'prevweek') {
    return [
      moment().startOf('week').subtract(1, 'week').toDate(),
      moment().startOf('week').toDate(),
    ];
  } else if (value === '14d') {
    return [moment().subtract(14, 'days').toDate(), new Date()];
  } else if (value === '30d') {
    return [moment().subtract(30, 'days').toDate(), new Date()];
  } else if (value === '60d') {
    return [moment().subtract(60, 'days').toDate(), new Date()];
  } else if (value === '90d') {
    return [moment().subtract(90, 'days').toDate(), new Date()];
  } else if (value === 'thismonth') {
    return [moment().startOf('month').toDate(), new Date()];
  } else if (value === 'prevmonth') {
    return [
      moment().startOf('month').subtract(1, 'month').toDate(),
      moment().startOf('month').toDate(),
    ];
  } else {
    throw new Error(`Invalid date range value: ${value}`);
  }
};
